"use client";

import { ChatBubbleIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import { useIntl } from "react-intl";
import { FeedbackDialog } from "../feedback-dialog/feedback-dialog";

export const FeedbackButton = ({
  hideTextOnMobile = false,
  isDark = true,
  userEmail,
  userName,
}: {
  hideTextOnMobile?: boolean | undefined;
  isDark?: boolean | undefined;
  userEmail?: string | undefined;
  userName?: string | undefined;
}) => {
  const intl = useIntl();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <button
        aria-label={intl.formatMessage({
          defaultMessage: "Provide feedback",
          id: "GdjHV6",
        })}
        className={`flex items-center gap-2 rounded-md px-3 py-2 text-sm transition-colors ${
          isDark
            ? "text-neutral-dark-11 hover:bg-neutral-dark-a-4 focus-visible:outline-neutral-dark-7"
            : "text-neutral-11 hover:bg-neutral-a-4 focus-visible:outline-neutral-7"
        }`}
        onClick={() => {
          setIsDialogOpen(true);
        }}
        title={intl.formatMessage({
          defaultMessage: "Provide feedback",
          id: "GdjHV6",
        })}
        type="button"
      >
        <ChatBubbleIcon className="size-4" />
        <span className={hideTextOnMobile ? "hidden sm:inline" : ""}>
          {intl.formatMessage({
            defaultMessage: "Send Feedback",
            id: "b11hht",
          })}
        </span>
      </button>

      <FeedbackDialog
        isOpen={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        userEmail={userEmail}
        userName={userName}
      />
    </>
  );
};
